import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFiltersChange, specializations }) => {
  const [locationError, setLocationError] = useState('');

  const handleFilterChange = (filterType, value) => {
    // Validate location: reject if too short (1 char) or contains only special chars
    if (filterType === 'location') {
      if (value && value?.trim()?.length === 1) {
        setLocationError('Saisissez au moins 2 caractères pour filtrer par localisation');
      } else if (value && /^[^a-zA-ZÀ-ÿ0-9]+$/?.test(value?.trim())) {
        setLocationError('Veuillez saisir un nom de ville ou quartier valide');
      } else {
        setLocationError('');
      }
    }
    onFiltersChange((prev) => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setLocationError('');
    onFiltersChange({
      specialization: '',
      location: '',
      availability: ''
    });
  };

  const hasActiveFilters = filters?.specialization || filters?.location || filters?.availability;

  return (
    <div className="bg-card border border-border rounded-2xl p-6 shadow-sm border-none">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-ios-title3 font-display font-display-semibold text-text-primary">
          Filtres
        </h3>
        {hasActiveFilters &&
        <Button
          variant="ghost"
          size="sm"
          onClick={clearFilters}
          className="text-brand-gold">

            Effacer
          </Button>
        }
      </div>

      <div className="space-y-4">
        {/* Specialization Filter */}
        <div>
          <label className="block text-ios-callout font-system font-body-medium text-text-primary mb-2">
            Spécialisation
          </label>
          <select
            value={filters?.specialization}
            onChange={(e) => handleFilterChange('specialization', e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-brand-gold focus:border-transparent text-ios-callout">

            <option value="">Toutes les spécialisations</option>
            {specializations?.map((spec) =>
            <option key={spec} value={spec}>
                {spec}
              </option>
            )}
          </select>
        </div>

        {/* Location Filter */}
        <div>
          <label className="block text-ios-callout font-system font-body-medium text-text-primary mb-2">
            Localisation
          </label>
          <div className="relative">
            <Icon
              name="MapPin"
              size={16}
              className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${locationError ? 'text-red-500' : 'text-text-secondary'}`} />

            <input
              type="text"
              value={filters?.location}
              onChange={(e) => handleFilterChange('location', e?.target?.value)}
              placeholder="Entrez une ville ou quartier"
              className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent text-ios-callout transition-colors ${
                locationError
                  ? 'border-red-400 focus:ring-red-400 bg-red-50/30 text-red-700 placeholder:text-red-400' :'border-border focus:ring-brand-gold'
              }`} />

          </div>
          {locationError && (
            <p className="mt-1.5 flex items-center gap-1 text-xs text-red-600">
              <Icon name="AlertCircle" size={12} color="currentColor" />
              {locationError}
            </p>
          )}
        </div>

        {/* Availability Filter */}
        <div>
          <label className="block text-ios-callout font-system font-body-medium text-text-primary mb-2">
            Disponibilité
          </label>
          <div className="space-y-2">
            {[
            { value: '', label: 'Toutes les disponibilités' },
            { value: 'today', label: 'Disponible aujourd\'hui' },
            { value: 'this_week', label: 'Cette semaine' },
            { value: 'next_week', label: 'Semaine prochaine' }]?.
            map((option) =>
            <label key={option?.value} className="flex items-center space-x-3 cursor-pointer">
                <input
                type="radio"
                name="availability"
                value={option?.value}
                checked={filters?.availability === option?.value}
                onChange={(e) => handleFilterChange('availability', e?.target?.value)}
                className="w-4 h-4 text-brand-gold border-border focus:ring-brand-gold" />

                <span className="text-ios-callout text-text-primary">
                  {option?.label}
                </span>
              </label>
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="pt-4 border-t border-border">
          <h4 className="text-ios-callout font-system font-body-medium text-text-primary mb-2">
            Accès rapide
          </h4>
          <div className="space-y-1">
            <button
              onClick={() => handleFilterChange('specialization', 'Real Estate')}
              className="w-full text-left px-3 py-2 rounded-lg hover:bg-surface/70 transition-colors text-ios-callout text-text-secondary flex items-center space-x-2">

              <Icon name="Home" size={16} />
              <span>Immobilier</span>
            </button>
            <button
              onClick={() => handleFilterChange('specialization', 'Inheritance')}
              className="w-full text-left px-3 py-2 rounded-lg hover:bg-surface/70 transition-colors text-ios-callout text-text-secondary flex items-center space-x-2">

              <Icon name="Users" size={16} />
              <span>Succession</span>
            </button>
            <button
              onClick={() => handleFilterChange('specialization', 'Contract Law')}
              className="w-full text-left px-3 py-2 rounded-lg hover:bg-surface/70 transition-colors text-ios-callout text-text-secondary flex items-center space-x-2">

              <Icon name="FileText" size={16} />
              <span>Contrats</span>
            </button>
          </div>
        </div>
      </div>
    </div>);

};

export default FilterPanel;